import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AthleteContext } from "./App";
import FilterTags from "./FilterTags";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Onboarding() {
    const { currentAthlete, setCurrentAthlete, sessionChecked } = useContext(AthleteContext);
    const navigate = useNavigate();

    const [csrfToken, setCsrfToken] = useState(null);
    const [nickname, setNickname] = useState("");
    const [eventFilters, setEventFilters] = useState([]);
    const [trainingFilters, setTrainingFilters] = useState([]);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        fetch(`${API}/api/csrf-token`, { credentials: "include" })
            .then(r => r.json())
            .then(data => setCsrfToken(data.csrfToken));
    }, []);

    // Pre-fill form whenever the athlete from context becomes available
    useEffect(() => {
        if (!currentAthlete) return;
        setNickname(currentAthlete.nickname || "");
        setEventFilters(currentAthlete.eventFilters || []);
        setTrainingFilters(currentAthlete.trainingFilters || []);
    }, [currentAthlete]);

    const save = () => {
        fetch(`${API}/athlete/onboarding`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "CSRF-Token": csrfToken
            },
            body: JSON.stringify({ nickname, eventFilters, trainingFilters })
        })
            .then(r => r.json())
            .then(() => {
                // Update context so the menu reflects a changed nickname immediately
                setCurrentAthlete(a => ({ ...a, nickname, eventFilters, trainingFilters }));
                setSaved(true);
            });
    };

    const logout = () => {
        fetch(`${API}/athlete/logout`, {
            method: "POST",
            credentials: "include",
            headers: { "CSRF-Token": csrfToken }
        })
            .then(() => {
                setCurrentAthlete(null);
                navigate("/");
            });
    };

    // Wait until the app-level session check has finished before deciding what to show
    if (!sessionChecked) return <p>Laden…</p>;

    if (!currentAthlete) {
        return (
            <div className="pane pane-center dark_pane">
                <h1>Niet ingelogd</h1>
                <p>Je bent niet aangemeld. <a href="/aanmelden">Meld je aan via Strava</a> om je profiel in te stellen.</p>
            </div>
        );
    }

    return (
        <div className="pane pane-center dark_pane">
            <div className="profile-header">
                {currentAthlete.profilePhoto && (
                    <img src={currentAthlete.profilePhoto} alt={currentAthlete.firstName} className="profile-photo" />
                )}
                <h1>Mijn profiel</h1>
            </div>
            <p>Welkom, <strong>{currentAthlete.firstName} {currentAthlete.lastName}</strong>.</p>

            {!currentAthlete.approved && (
                <p className="pending-notice">
                    Je aanmelding wacht nog op goedkeuring door de beheerder. Je routes worden daarna gesynchroniseerd.
                </p>
            )}

            <label htmlFor="nickname">Weergavenaam (optioneel)</label>
            <input
                id="nickname"
                value={nickname}
                onChange={e => setNickname(e.target.value)}
                placeholder="Naam of nickname"
            />

            <label>Activiteitsfilter evenementen</label>
            <small>Zoektermen die in de naam of beschrijving van een Strava-activiteit voorkomen.</small>
            <FilterTags
                filters={eventFilters}
                onChange={setEventFilters}
                placeholder="bijv. Hartekind"
            />

            <label>Activiteitsfilter trainingen</label>
            <small>Zelfde als boven, maar gemarkeerd als training op de kaart.</small>
            <FilterTags
                filters={trainingFilters}
                onChange={setTrainingFilters}
                placeholder="bijv. training"
            />

            <div className="onboarding-actions">
                <button onClick={save}>Opslaan</button>
                <button className="btn-ghost" onClick={logout}>Afmelden</button>
            </div>

            {saved && <p className="save-success">Instellingen opgeslagen!</p>}
        </div>
    );
}
